import { Component, OnInit } from '@angular/core';
import { UtilService } from '../../../../core/services/util/util.service';
import { ClaimService } from '../../services/claim/claim.service';
import { MatDialog } from '@angular/material/dialog';
import { ClaimCustomerDialogComponent } from '../../components/claim-customer-dialog/claim-customer-dialog.component';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { faArrowDown, faFileExcel } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrl: './claim.component.css'
})
export class ClaimComponent implements OnInit {
  faArrowDown = faArrowDown;
  faFileExcel = faFileExcel;

  liffUrlClaim = environment.liff_url_claim;

  items: any[] = []
  offset: number = 0;
  limit: number = 10;
  countClaim: any = {
    'ongoing': 0,
    'success': 0
  }
  state = 'ongoing';  // ongoing, success

  shopId: string = this.authService.selectedShop?.shop_id || '';

  showDetail = false;
  claimDetail: any = {}

  isLoaded = false;
  loadingMore = false
  statusGetClaim: any = {
    ongoing: 'pending',
    success: 'success'
  }

  permissionsExportClaim = ['admin', 'manager', 'supervisor'];

  constructor(
    private authService: AuthService,
    private utilService: UtilService,
    private claimService: ClaimService,
    private dialog: MatDialog,
  ) { }

  async ngOnInit(): Promise<void> {
    this.reloadData()
  }

  async reloadData() {
    this.isLoaded = false;
    if (this.state === 'ongoing') {
      this.items = await this.getOrderList(this.statusGetClaim.ongoing);
      this.countClaim['success'] = await this.getCountClaim(this.statusGetClaim.success)
    } else {
      this.items = await this.getOrderList(this.statusGetClaim.success);
      this.countClaim['ongoing'] = await this.getCountClaim(this.statusGetClaim.ongoing)
    }
    console.log(this.countClaim);
    this.isLoaded = true;
  }

  getClaimDetail(filter: any) {
    return this.claimService.getClaim(this.shopId, filter).then((response: any) => {
      if (response.success) {
        return response.data.sort((a: any, b: any) => b.created.date - a.created.date)
      } else {
        return []
      }
    })
  }

  async getOrderList(status: string): Promise<any[]> {
    const filter = {
      status,
      offset: this.offset,
      limit: this.limit,
      fields: 'claim_ref,claim_id,product,response,created,is_receipt,is_delivery'
    }
    return this.claimService.getClaim(this.shopId, filter).then((response: any) => {
      if (!response.success) {
        this.countClaim[this.state] = 0
        return [];
      }
      this.countClaim[this.state] = response.count
      return response.data;
    })
  }

  getCountClaim(status: string) {
    const filter = {
      status,
      offset: 0,
      limit: 1,
      fields: 'claim_id'
    }
    return this.claimService.getClaim(this.shopId, filter).then((response: any) => {
      console.log(response);
      if (!response.success) return 0;
      return response.count
    })
  }

  async loadMore() {
    this.loadingMore = true
    this.offset = this.offset + this.limit;
    let orderResponse = [];
    if (this.state === 'ongoing') {
      orderResponse = await this.getOrderList(this.statusGetClaim.ongoing);
    } else {
      orderResponse = await this.getOrderList(this.statusGetClaim.success);
    }
    this.items.push(...orderResponse);
    this.loadingMore = false
  }

  dateFormat(date: number) {
    return this.utilService.dayjs(date).format('DD/MM/YYYY, HH:mm')
  }

  async clickShowDetail(claim_id: string) {
    console.log(claim_id)
    const filter = {
      claim_id: claim_id
    }
    const fetchClaim = await this.getClaimDetail(filter)
    this.claimDetail = fetchClaim[0]
    this.showDetail = true;
  }

  callBackClaimDetail = (data: any) => {
    console.log(data)

    if (data.followUp) {
      console.log(`${this.liffUrlClaim}/follow-up?id=${this.claimDetail.claim_id}&shop-id=${this.shopId}`)
      const dialogRef = this.dialog.open(ClaimCustomerDialogComponent, {
        data: { qrcode: `${this.liffUrlClaim}/follow-up?id=${this.claimDetail.claim_id}&shop-id=${this.shopId}` }
      });
    } else {
      this.showDetail = false;
    }
  }

  displayStatus(status: string, is_receipt: any, is_delivery: boolean) {
    /**
      S1 =	ส่ง SUP
      S2 =	ส่งช่าง
      S3 =	รอสินค้า (Remax)
      S4 =	รอสินค้า (ซัพนอก)
      S5 =	รอดำเนินการ
      S6 =	ปิดงาน
      S7 =	อื่นๆ
    */

    if (status === 'ปิดงาน') {
      if (is_delivery) {
        return 'จัดส่งให้ลูกค้าแล้ว'
      } else {
        if (is_receipt) {
          return 'รับเข้าแล้ว'
        } else {
          return 'รอร้านค้ารับเข้า'
        }
      }
    }
    return status
  }

  colorStatus(status: string, is_receipt: any, is_delivery: boolean) {
    /**
      S1 =	ส่ง SUP
      S2 =	ส่งช่าง
      S3 =	รอสินค้า (Remax)
      S4 =	รอสินค้า (ซัพนอก)
      S5 =	รอดำเนินการ
      S6 =	ปิดงาน
      S7 =	อื่นๆ
    */

    if (status === 'ปิดงาน') {
      if (is_delivery) {
        return '!bg-lime-200'
      } else {
        if (is_receipt) {
          return '!bg-lime-200'
        } else {
          return '!bg-orange-300'
        }
      }
    }
    return status
  }

  changeState(state: string) {
    if (this.state !== state) {
      this.state = state;
      this.offset = 0;
      this.reloadData();
    }
  }

  canExportClaim() {
    return this.permissionsExportClaim.includes(this.authService.user.role)
  }

  async downloadClaim() {
    const cliamOngoing: any = await this.claimService.getClaim(this.shopId, {
      status: this.statusGetClaim.ongoing,
      fields: 'claim_ref,claim_id,product,response,created,is_receipt,status,request,order_no,is_delivery'
    }).then((response: any) => {
      if (!response.success) {
        return [];
      }
      return response.data;
    })

    const claimSuccess: any = await this.claimService.getClaim(this.shopId, {
      status: this.statusGetClaim.success,
      fields: 'claim_ref,claim_id,product,response,created,is_receipt,status,request,order_no,is_delivery'
    }).then((response: any) => {
      if (!response.success) {
        return [];
      }
      return response.data;
    })

    const allClaim = [...cliamOngoing, ...claimSuccess].sort((a, b) => a.created.date - b.created.date)

    const data = []
    for (const claim of allClaim) {
      let detial: any = {
        claim_ref: claim.claim_ref,
        claim_serial: claim.product.serial_no,
        product_name: claim.product.name,
        claim_date: this.utilService.dayjs(claim.created.date).format('DD/MM/YYYY, HH:mm'),
        status: claim.status === 'success' ? this.displayStatus(claim?.response?.claimStatus, claim.is_receipt, claim.is_delivery) : 'กำลังดำเนินการ',
        description: `${claim.request.description}`,
        claim_type: `${claim.order_no ? 'ลูกค้า' : 'ร้านค้า'}`,
        user_claim: `${claim.request.firstname} ${claim.request.lastname} ${claim.request.nickname}`,
        phone: `${claim.request.tel}`,
        claim_status: `${claim?.response?.claimStatus}`,
        process_detial: '',
        return_product_name: '',
        return_serial: ''
      }

      if (claim?.response?.claimStatus === 'ปิดงาน') {
        detial.process_detial = `${claim?.response?.serialClaim && claim?.response?.serial !== claim?.response?.serialClaim ? 'เปลี่ยนบาร์ใหม่' : 'บาร์เดิม'}`
        detial.return_product_name = `${claim?.response?.productClaimName || claim.product.name}`
        detial.return_serial = claim?.response?.serialClaim ? claim?.response?.serialClaim : claim?.response?.serial
      }
      data.push(detial)
    }
    console.log(data)
    await this.claimService.generateClaimReport(data, `รายการเคลม ${this.shopId}`)
  }

}
